import IconButton from '@zvuk-b2b/react-uikit/ui/IconButton';
import React, { FC, useEffect, useState } from 'react';
import { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';
import IconHeart from '@zvuk-b2b/react-uikit/ui/icons/Heart';
import classNames from 'classnames';
import { toast } from '@shared/ui';
import { DEFAULT_ERROR_MESSAGE } from '@shared/config';
import { MediaListProps, MediafileType } from 'application/components/MediaList/types';
import AnalyticsService, { EventNameAMP, ParamNameAMP } from 'application/services/AnalyticsService';
import { useMediaLikeContext } from 'application/components/MediaList/MediaLikeProvider';
import { MediaFileTypes } from 'application/pages/types';
import { TEXTS } from './consts';

import styles from './index.module.scss';

interface LikeButtonProps {
  id: MediafileType['id'];
  streamId: MediaListProps['streamId'];
  isLiked: boolean;
  isDisliked: boolean;
  title: string;
  withLikes?: boolean;
  type?: number;
}

const MediaListItemIconsLike: FC<LikeButtonProps> = (props) => {
  const { id, streamId, isLiked: initialLiked, isDisliked, title, withLikes, type } = props;

  const isPromo = type === MediaFileTypes.PROMO;
  const [isLikeLoading, setIsLikeLoading] = useState(false);
  const [isLiked, setIsLiked] = useState(initialLiked);

  const { unLikeMediaFile, likeMediaFile } = useMediaLikeContext();

  const errorHandler = (res: boolean) => {
    if (!res) {
      setIsLiked(isLiked);

      toast.error(DEFAULT_ERROR_MESSAGE);
    }
  };

  const handleLike = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    setIsLiked(!isLiked);
    setIsLikeLoading(true);

    if (isLiked) {
      unLikeMediaFile(streamId, id)
        .then(errorHandler)
        .catch(errorHandler)
        .finally(() => {
          AnalyticsService.event(EventNameAMP.LIKE_TRACK_UNPRESSED, {
            [ParamNameAMP.TITLE]: title,
          });
          setIsLikeLoading(false);
        });

      return;
    }

    likeMediaFile(streamId, id)
      .then(errorHandler)
      .catch(errorHandler)
      .finally(() => {
        AnalyticsService.event(EventNameAMP.LIKE_TRACK_PRESSED, {
          [ParamNameAMP.TITLE]: title,
        });
        setIsLikeLoading(false);
      });
  };

  useEffect(() => {
    if (isDisliked) {
      setIsLiked(false);
    }
  }, [isDisliked]);

  useEffect(() => {
    setIsLiked(initialLiked);
  }, [initialLiked]);

  if (!withLikes || isPromo) {
    return null;
  }

  return (
    <IconButton
      className={classNames(styles.Like, { [styles.LikeLiked]: isLiked })}
      elementId="button_media_list_item_like"
      onClick={handleLike}
      hint={TEXTS.LIKE}
      hintPlacement={HintPlacement.PLACEMENT_TOP_START}
      isDisabled={isDisliked}
      isLoading={isLikeLoading}>
      <IconHeart />
    </IconButton>
  );
};

export default MediaListItemIconsLike;
